import flatten from 'lodash/flatten';
import urlJoin from '@framework/url/helpers/urlJoin';
import baseUrl from '@framework/url/baseUrl';
import isServer from '@framework/router/Next/isServer';
import domain from '@framework/config/domain';
import evercallConfig from '../config';
import dmPortalUrl from '@dm-portal/url';
import usersUrl from '@users/url';
import appendConsentParams from '@framework/cookie-consent/appendConsentParams';
import ROUTES from './urlConstants';

export default {
  getUrl(uris: Array<string> | string = []) {
    if (!Array.isArray(uris)) {
      uris = [uris];
    }
    uris = flatten(uris).filter((uri) => !!uri);
    return urlJoin(`${ domain.protocol }//${ evercallConfig.hostname }`, ...uris);
  },

  getRpcUrl({ disableProxy = false }: { disableProxy?: boolean } = {}): string {
    return baseUrl.getRpcUrl({ disableProxy });
  },

  getWebServiceRpcUrl(): string {
    return !isServer()
      ? `${ domain.protocol }//${ window.location.host }/proxy/evercall/rpc`
      : baseUrl.getRestUrl('evercall/rpc');
  },

  getPropagateCallbackUrl(url: string): string {
    return baseUrl.getRestUrl(
      `/propagate?callbackUrl=${ encodeURIComponent(url) }&tenant=${ evercallConfig.code }`,
    );
  },

  getLoginUrl(): string {
    return appendConsentParams(usersUrl.getLoginUrl(
      this.getPropagateCallbackUrl(dmPortalUrl.getUrl('/evercall')),
      evercallConfig.code,
    ));
  },

  getBaseFilesUrl(...uris: (string | string)[]): string {
    return baseUrl.getApiUrl('evercall/files', ...uris);
  },

  getDashboardLoginCallbackUrl(dashboardId: string): string {
    return this.getUrl([`${ ROUTES.DASHBOARD }/${ dashboardId }`]);
  },
};
